import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { VehicleType } from '@/types/vehicle-type'

export function createVehicleType(
  body: VehicleType
): Promise<AxiosResponse<VehicleType>> {
  return instance.post(`/vehicle-type`, body)
}
